module.exports = __webpack_public_path__ + "img/View developer documentation.690c5184.svg";